import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { SectionLabel } from '@/components/ui/section-label';
import { cn } from '@/lib/utils';

export type AdminSectionCardProps = {
  title: string;
  description?: string;
  icon?: LucideIcon;
  className?: string;
  children: ReactNode;
  footer?: ReactNode;
};

export function AdminSectionCard({
  title,
  description,
  icon: Icon,
  className,
  children,
  footer,
}: AdminSectionCardProps) {
  return (
    <Card as="section" className={cn('flex flex-col gap-5', className)}>
      <header className="space-y-1">
        <SectionLabel icon={Icon}>{title}</SectionLabel>
        {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
      </header>
      <div className="flex flex-col gap-4">{children}</div>
      {footer && <div className="pt-2">{footer}</div>}
    </Card>
  );
}
